import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @title={{i18n "download_calendar.title"}}
  class="download-calendar-modal"
  @closeModal={{@closeModal}}
>
  <:body>
    <div class="control-group">
      <div class="ics">
        <label class="radio" for="ics">
          <RadioButton
            id="ics"
            @name="select-calendar"
            @value="ics"
            @selection={{this.selectedCalendar}}
            @onChange={{fn this.selectCalendar "ics"}}
          />
          {{i18n "download_calendar.save_ics"}}
        </label>
      </div>
      <div class="google">
        <label class="radio" for="google">
          <RadioButton
            id="google"
            @name="select-calendar"
            @value="google"
            @selection={{this.selectedCalendar}}
            @onChange={{fn this.selectCalendar "google"}}
          />
          {{i18n "download_calendar.save_google"}}
        </label>
      </div>
    </div>

    <div class="control-group remember">
      <label class="checkbox-label">
        <Input @type="checkbox" @checked={{this.remember}} />
        <span>{{i18n "download_calendar.remember"}}</span>
      </label>
      <span>{{i18n "download_calendar.remember_explanation"}}</span>
    </div>
  </:body>
  <:footer>
    <DButton
      class="btn-primary"
      @action={{this.downloadCalendar}}
      @label="download_calendar.download"
    />
    <DButton
      class="btn-flat d-modal-cancel"
      @action={{@closeModal}}
      @label="cancel"
    />
  </:footer>
</DModal>
*/
{
  "id": "jR/Ja53k",
  "block": "[[[8,[39,0],[[24,0,\"download-calendar-modal\"]],[[\"@title\",\"@closeModal\"],[[28,[37,1],[\"download_calendar.title\"],null],[30,1]]],[[\"body\",\"footer\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"ics\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"radio\"],[14,\"for\",\"ics\"],[12],[1,\"\\n          \"],[8,[39,2],[[24,1,\"ics\"]],[[\"@name\",\"@value\",\"@selection\",\"@onChange\"],[\"select-calendar\",\"ics\",[30,0,[\"selectedCalendar\"]],[28,[37,3],[[30,0,[\"selectCalendar\"]],\"ics\"],null]]],null],[1,\"\\n          \"],[1,[28,[35,1],[\"download_calendar.save_ics\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"google\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"radio\"],[14,\"for\",\"google\"],[12],[1,\"\\n          \"],[8,[39,2],[[24,1,\"google\"]],[[\"@name\",\"@value\",\"@selection\",\"@onChange\"],[\"select-calendar\",\"google\",[30,0,[\"selectedCalendar\"]],[28,[37,3],[[30,0,[\"selectCalendar\"]],\"google\"],null]]],null],[1,\"\\n          \"],[1,[28,[35,1],[\"download_calendar.save_google\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"control-group remember\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"checkbox-label\"],[12],[1,\"\\n        \"],[8,[39,4],null,[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"remember\"]]]],null],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,1],[\"download_calendar.remember\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,1],[\"download_calendar.remember_explanation\"],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],[[[1,\"\\n    \"],[8,[39,5],[[24,0,\"btn-primary\"]],[[\"@action\",\"@label\"],[[30,0,[\"downloadCalendar\"]],\"download_calendar.download\"]],null],[1,\"\\n    \"],[8,[39,5],[[24,0,\"btn-flat d-modal-cancel\"]],[[\"@action\",\"@label\"],[[30,1],\"cancel\"]],null],[1,\"\\n  \"]],[]]]]]],[\"@closeModal\"],false,[\"d-modal\",\"i18n\",\"radio-button\",\"fn\",\"input\",\"d-button\"]]",
  "moduleName": "discourse/components/modal/download-calendar.hbs",
  "isStrictMode": false
});